import "./App.css";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Services from "./Component/Services";
import Home from "./Component/Home";
import Header from "./Component/Header";
import UserList from "./Component/UserManagement/UserList";
import CreateEditUser from "./Component/UserManagement/CreateEditUser";
import ImportUsers from "./Component/UserManagement/ImportUsers";
import CreateEditRole from "./Component/UserRoles/CreateEditRole";
import AddServices from "./Component/ManageServices/AddServices";
import ServicesList from "./Component/ManageServices/ServicesList";
import SessionExpired from "./Component/SessionExpired";
import ResetPassword from "./Component/UserManagement/ResetPassword";
import RoleList from "./Component/UserRoles/RoleList";
import { Box } from "@mui/material";
import TariffData from "./Component/TariffData/TariffData";
import FourKitesRuleList from "./Component/ManageFourKitesRules/FourKitesRuleList";
import AddFourKitesRule from "./Component/ManageFourKitesRules/AddFourKitesRule";
import ImportFourKitesRule from "./Component/ManageFourKitesRules/ImportFourKitesRule";

function App() {
  return (
    <BrowserRouter>
      <Box sx={{ display: "flex" }}>
        <Header></Header>
        <Box component="main" className="blue-container">
          <Routes>
            <Route path="/" element={<Home></Home>}></Route>
            <Route path="/Services" element={<Services></Services>}></Route>
            <Route path="/UserList" element={<UserList></UserList>}></Route>
            <Route path="/ImportUsers" element={<ImportUsers></ImportUsers>}></Route>
            <Route
              path="/AddUser"
              element={<CreateEditUser></CreateEditUser>}
            ></Route>
            <Route
              path="/CreateEditUser"
              element={<CreateEditUser></CreateEditUser>}
            ></Route>
            <Route
              path="/AddUser"
              element={<CreateEditUser></CreateEditUser>}
            ></Route>
            <Route
              path="/CreateEditUser"
              element={<CreateEditUser></CreateEditUser>}
            ></Route>

            <Route path="/RoleList" element={<RoleList></RoleList>}></Route>
            <Route
              path="/CreateEditRole"
              element={<CreateEditRole></CreateEditRole>}
            ></Route>
            <Route
              path="/ServicesList"
              element={<ServicesList></ServicesList>}
            ></Route>
            <Route
              path="/AddServices"
              element={<AddServices></AddServices>}
            ></Route>
            <Route
              path="/SessionExpired"
              element={<SessionExpired></SessionExpired>}
            ></Route>
            <Route
              path="/ResetPassword"
              element={<ResetPassword></ResetPassword>}
            ></Route>
              <Route
              path="/TariffData"
              element={<TariffData></TariffData>}
            ></Route>
            <Route
              path="/Fourkites"
              element={<FourKitesRuleList></FourKitesRuleList>}
            ></Route>
               <Route
            path="/AddFourKitesRule"
            element={<AddFourKitesRule></AddFourKitesRule>}
          ></Route>
          <Route path="/ImportFourKitesRule" element={<ImportFourKitesRule></ImportFourKitesRule>}></Route>
          </Routes>
        </Box>
      </Box>
    </BrowserRouter>
  );
}

export default App;
